import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, CalendarDays, Users, LayoutGrid, Mail, GraduationCap, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSeo } from "@/hooks/useSeo";

const cards = [
  { key: "news", label: "Berita", icon: Newspaper, to: "/admin/berita", color: "bg-emerald-100 text-emerald-700" },
  { key: "activities", label: "Kegiatan", icon: CalendarDays, to: "/admin/kegiatan", color: "bg-blue-100 text-blue-700" },
  { key: "teachers", label: "Guru", icon: Users, to: "/admin/guru", color: "bg-amber-100 text-amber-700" },
  { key: "gallery", label: "Galeri", icon: LayoutGrid, to: "/admin/galeri", color: "bg-purple-100 text-purple-700" },
  { key: "contacts", label: "Pesan Masuk", icon: Mail, to: "/admin/kontak", color: "bg-rose-100 text-rose-700" },
  { key: "registration_links", label: "Link Pendaftaran", icon: GraduationCap, to: "/admin/pendaftaran", color: "bg-teal-100 text-teal-700" },
];

const AdminDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({});
  useSeo("Dashboard Admin");

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div className="mb-8 rounded-2xl bg-gradient-to-br from-emerald-600 to-emerald-800 p-8 text-white shadow-sm">
        <h1 className="font-heading text-2xl font-bold">Selamat Datang, Admin 👋</h1>
        <p className="mt-1 text-emerald-100">{user?.email}</p>
        <p className="mt-3 max-w-xl text-sm text-emerald-50/90">Kelola seluruh konten website Madrasah Ibtidaiyah Futuhiyyah dari panel ini.</p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`admin-stat-${c.key}`} className="group flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:-translate-y-1 hover:shadow-md">
            <div className={`flex h-14 w-14 items-center justify-center rounded-xl ${c.color}`}><c.icon className="h-7 w-7" /></div>
            <div className="flex-1">
              <p className="font-heading text-2xl font-bold text-slate-900">{stats[c.key] ?? 0}</p>
              <p className="text-sm text-slate-500">{c.label}</p>
            </div>
            <ArrowRight className="h-4 w-4 text-slate-300 transition-colors group-hover:text-emerald-600" />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
